/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchApprovalRequestSettingsPathParams = NonNullable<
  operations['patchApprovalRequestSettings']['parameters']['path']
>;

export type PatchApprovalRequestSettingsRequestBody = OperationRequestBodyContent<
  operations['patchApprovalRequestSettings']
>;

export interface Input extends PatchApprovalRequestSettingsPathParams {
  apiVersion?: string;
  body: PatchApprovalRequestSettingsRequestBody;
  header: NonNullable<operations['patchApprovalRequestSettings']['parameters']['header']>;
}

export async function patchApprovalRequestSettings(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/approval-requests/projects/{projectKey}/settings', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
